import { Map, OrderedMap, Record } from "immutable";
import keyMirror from "key-mirror";

export const CASE_TYPES = new Map({
    INBOX: [1],
    PARTICIPATED: [2, 3]
});

export const CASE_STATUS_TYPES = new Map({
    "In Progress": 1,
    Rejected: 2,
    Closed: 3
});

export const CASE_PRIORITY_TYPES = new Map({
    Normal: 1,
    High: 2
});

export const CASE_UPGRADE_ACTIONS = new (Record(
    keyMirror({
        PROCEED: null,
        REFER: null,
        REJECT: null,
        ASSIGN: null,
        REASSIGN: null,
        HOLD: null,
        OPEN: null,
        BULK_PROCEED: null,
        BULK_REFER: null,
        BULK_SANCTION: null,
        PROCEED_BULK_CASES: null,
        UNASSIGN: null,
        PULL_BACK_TO_PS_KIT: null
    })
))();

export const UNDERWRITING_JOB_TYPES = new Map({
    CREATED: 1,
    PROCESSING: 2,
    SUCCESSFUL: 3,
    FAILED: 4
});

export const SANCTION_CONDITION_STATUS = new Map({
    "Not Applicable": 1,
    Active: 2,
    Fulfilled: 3,
    Terminated: 4
});

export const CASE_VIEW_ACTION = "view";

export const PERMISSIONS_MAP = new Map({
    view_case_summary_card: true,

    case_initiation: true,

    page_case_details: true,

    case_details_supply_chain_view: true,

    case_details_supply_chain_edit: true,

    case_details_associates_view: true,

    case_details_associates_edit: true,

    case_details_addresses_view: true,

    case_details_addresses_edit: true,

    case_details_bank_accounts_view: true,

    case_details_bank_accounts_edit: true,

    page_documents: true,

    documents_view: true,

    documents_edit: true,

    page_credit_appraisal: true,

    credit_appraisal_cibil_view: true,

    credit_appraisal_cibil_edit: true,

    credit_appraisal_bank_statement_analysis_view: true,

    credit_appraisal_bank_statement_analysis_edit: true,

    credit_appraisal_sales_data_view: true,

    credit_appraisal_sales_data_edit: true,

    credit_appraisal_questionnaire_view: true,

    credit_appraisal_questionnaire_edit: true,

    page_financial_analysis: true,

    financial_analysis_view: true,

    financial_analysis_edit: true,

    page_scorecard: true,

    scorecard_progcap_view: true,

    scorecard_progcap_edit: true,

    scorecard_bank_view: true,

    scorecard_bank_edit: true,

    page_assessment_report: true,

    assessment_report_view: true,

    page_credit_summary: true,

    credit_summary_view: true,

    case_summary_edit: true,

    case_summary_company_edit: true,

    page_post_sanction_documentation: true,

    post_sanction_documentation_view: true,

    post_sanction_documentation_edit: true
});

export const LOCATION_TYPES = keyMirror({
    CITY: null,
    STATE: null,
    COUNTRY: null
});

export const SALES_ANALYSIS_DISPLAY_YEAR = new Map({
    "FINANCIAL YEAR": 1,
    "TRADE YEAR_JAN": 2,
    TRADE_YEAR_AUG: 3
});

export const SALES_ANALYSIS_DISPLAY_CURRENCY = new Map({
    "IN LACS": 1,
    "IN CR": 2,
    "IN FULL NUMBER": 3
});

export const NATURE_OF_ASSOCIATION_TYPES = new Map({
    Proprietor: 1,
    Partner: 2,
    Director: 3,
    Promoter: 4,
    Investor: 5,
    Management: 6,
    Friend: 7,
    Related: 8,
    Professional: 9,
    Accountant: 10,
    Karta: 11,
    Other: 12,
    Guarantor: 13
});
export const ONBOARDING_ASSOCIATION_TYPES = new Map({
    "Anchor Led": 1,
    "Distributor Led": 2,
    "Others": 3
});

export const DESIGNATION_TYPES = new Map({
    Proprietor: 1,
    Partner: 2,
    Director: 3,
    "Finance Head": 4,
    "Finance Manager": 5,
    "Finance Officer": 6,
    Accountant: 7,
    Employee: 8,
    Promoter: 9
});

export const GENDER_TYPES = new Map({
    Male: 1,
    Female: 2,
    Other: 3
});

export const TITLE_TYPES = new Map({
    "Mr.": 1,
    "Ms.": 2,
    "Mrs.": 3,
    "--": 4
});

export const RECEIVED_DOCUMENTS = new Map({
    "NACH" :1,
    "Cheques" :2,
    "Application Form" :3,
    "Declaration Letter" :4,
    "BSV" :5,
    "Stamp Paper" :6,
    "Sanction Letter" :7,
    "PS-KIT" :8,
    "Authorization Letter" :9,
    "KYC" :10,
    "Recommendation Letter" :11,
    "Program Agreement" :12,
    "Utility Bill" :13,
    "Vernacular" :14,
    "DPN" :15,
    "Others" :16
});
export const PAYEE_NAME = new Map({
    "Desiderata": 1,
    "Bank": 2,
    "Progcap": 3,
    "IDFC": 4,
    "Others": 5
});
export const SENDER_TYPE = new Map({
    "Insider": 1,
    "Outsider": 2,
    "Others": 3
});
export const RECEIVED_BY = new Map({
    "Via Courier": 1,
    "By Hand": 2,
    "Others": 3
});
export const PENDENCY = new Map({
    "Yes": 1,
    "No": 2,
    "Resolved": 3,
    "Conflict": 4
});
export const PENDENCY_REASON = new Map({
    "NACH" :1,
    "Cheques" :2,
    "Application Form" :3,
    "Declaration Letter" :4,
    "BSV" :5,
    "Stamp Paper" :6,
    "Sanction Letter" :7,
    "PS-KIT" :8,
    "Authorization Letter" :9,
    "KYC" :10,
    "Recommendation Letter" :11,
    "Program Agreement" :12,
    "Utility Bill" :13,
    "Vernacular" :14,
    "DPN" :15,
    "Others" :16
});
export const COURIER_COMPANY = new Map({
    "city commercial courier& cargo" :1,
    "AGC Ganga" :2,
    "Air Star Courier" :3,
    "Airways courier" :4,
    "Akash Ganga Couriers" :5,
    "All India courier" :6,
    "Baroda Hub " :7,
    "Blue Dart" :8,
    "Blue Sky" :9,
    "By Hand" :10,
    "Delhivery" :11,
    "Direct Standard" :12,
    "DTDC" :13,
    "Ecom Express" :14,
    "Faster Logistics" :15,
    "Fedex Courier" :16,
    "Flyking Courier" :17,
    "GMC Courier" :18,
    "Gokulam Courier " :19,
    "Good Luck" :20,
    "ICL " :21,
    "India Post" :22,
    "Jetline Courier" :23,
    "Kerry Indev Express" :24,
    "Madhur Courier Services" :25,
    "Mahavir Couriers" :26,
    "Mark Express" :27,
    "Nandan Courier" :28,
    "ON Dot Courier" :29,
    "Prime Track" :30,
    "Priya retail india" :31,
    "Professional Couriers" :32,
    "Pushpak Couriers" :33,
    "Reliance Courier" :34,
    "Shiprocket" :35,
    "Shree Anjani Couriers" :36,
    "Shree Mahabali Express" :37,
    "Shree Mahavir Express" :38,
    "Shree Maruti Courier Service" :39,
    "Shree Nandan Couriers" :40,
    "Shree Tirupati Courier" :41,
    "Sky King" :42,
    "Speed & Safe Courier" :43,
    "Super Group Courier" :44,
    "The Profesional Couriers" :45,
    "Tirupati Courier Services" :46,
    "Trackon" :47,
    "Udaan Express" :48,
    "World Pak Courier" :49,
    "Xpressbees Courier" :50,
    "Yes Couriers" :51,
    "Others" :52,

});

export const COMPANY_TYPES = new Map({
    Anchor: 1,
    Distributor: 2,
    Retailer: 3
});

export const CONSTITUTION_TYPES = new Map({
    Proprietorship: 1,
    Partnership: 2,
    "Private Limited": 3,
    "Public Limited": 4,
    Huf: 5,
    LLP: 6
});

export const BUSINESS_NATURE_TYPES = new Map({
    A: 1,
    B: 2,
    C: 3
});

export const BUSINESS_CATEGORY_TYPES = new Map({
    MSME: 1,
    SME: 2,
    MICRO: 3,
    SMALL: 4,
    MEDIUM: 5,
    LARGE: 6
});

export const INDUSTRY_CATEGORY_TYPES = new Map({
    Manufacturing: 1,
    Distribution: 2,
    "Whole Sale": 3,
    Trading: 4,
    Broking: 5,
    "Service Provider": 6,
    Importing: 7,
    Exporting: 8,
    Agriculture: 9,
    Dealers: 10
});

export const ADDRESSES_TYPES = new Map({
    Registered: 1,
    Office: 2,
    Factory: 3,
    Warehouse: 4,
    Residence: 5,
    Permanent: 6
});

export const RESIDENCE_TYPES = new Map({
    Rented: 2,
    Owned: 1
});

export const APPLICANT_TYPES = new Map({
    "Co-Applicant": 1,
    Guarantor: 2,
    Reference: 3,
    "Key Contact": 4,
    "Regional Office": 5,
    Other: 6,
    "D2R Guarantor": 7,
    Applicant: 8
});

export const BANK_ACCOUNT_TYPES = new Map({
    Saving: 1,
    Current: 2,
    OverDraft: 3,
    CashCredit: 4,
    "Disbursal & Withhold": 5,
    Loan: 6,
    Withhold: 7,
    Disbursal: 8,
});

export const LEDGER_DATA_SOURCE = new Map({
    "Tally Sync": 1,
    "Manual": 2,
    Other: 3,
    Busy: 5
});

export const CHEQUE_TYPES = new Map({
    Installment: 1,
    Security: 2
});

export const CHEQUE_STATUS_TYPES = new Map({
    Vault: 1,
    Realised: 2,
    Returned: 3,
    Destroyed: 4
});

export const BANK_ACCOUNT_STATUS_TYPES = new Map({
    Active: 1,
    Inactive: 2
});

export const LIMIT_TYPES = new Map({
    EXCESS: 3
});

export const RELATIONSHIP_WITH_COMPANY_TYPES = new Map({
    Management: 1,
    Employee: 2
});

export const COMPANY_STATUS_TYPES = new Map({
    Active: 1,
    Inactive: 2,
    "Account Suspend": 3,
    "Limit Blocked": 4,
    "Closed By Payment": 5,
    "Settled and Closed": 6,
    "Settled Post Write Off": 7
});

export const GROSS_ANNUAL_INCOME_TYPES = new Map({
    "Less than 100k": 1,
    "Less than 500k": 2,
    "Less than 1000k": 3,
    "Less than 1500k": 4,
    "Less than 2500k": 5,
    "Less than 5000k": 6,
    "Above 5000k": 7
});

export const PROFESSION_TYPES = new Map({
    Professional: 1,
    "Public Sector": 2,
    "Government Sector": 3,
    Business: 4,
    "Private Sector Service": 5,
    "Self Employed": 6,
    Retired: 7,
    "House Wife": 8,
    Student: 9,
    Other: 10
});

export const EDUCATION_TYPES = new Map({
    BELOW_SSC: 1,
    SSC: 2,
    HSC: 3,
    GRADUATE: 4,
    POST_GRADUATE: 5,
    PROFESSIONAL: 6
});

export const MARITIAL_STATUS_TYPES = new Map({
    Single: 1,
    Married: 2
});

export const NATIONALITY_TYPES = new Map({
    Indian: 1,
    Other: 2
});

export const CATEGORY_TYPES = new Map({
    GENERAL: 1,
    OBC: 2,
    SC: 3,
    ST: 4,
    OTHER: 5
});

export const INVOICE_STAGES_TYPES = new Map({
    PENDING_VERIFICATION: 1,
    DECLINED: 2,
    PENDING_APPROVAL: 3,
    SIGNED: 4,
    REJECTED: 5,
    PENDING_DISBURSAL: 6,
    DISBURSED_AND_OPEN: 7,
    CLOSED: 8
});

export const INVOICE_STATUS_TYPES = new Map({
    UNDEFINED: 0,
    SUBMITTED: 1,
    VERIFIED: 2,
    SIGNED: 3,
    DECLINED: 4,
    APPROVED: 5,
    INVOICE_STALE: 6,
    LIMIT_BLOCK: 7,
    ACCOUNT_SUSPEND: 8,
    BORROWER_LIMIT_EXHAUST: 9,
    DISTRIBUTOR_LIMIT_EXHAUST: 10,
    ANCHOR_LIMIT_EXHAUST: 11,
    PRODUCT_LIMIT_EXHAUST: 12,
    REJECTED: 13,
    PENDING_DISBURSAL: 14,
    OPEN: 15,
    REPAID: 16,
    CLOSED: 17,
    CANCELLED: 18,
    DUPLICATE: 19,
    CREATED: 20,
    WITHHOLD_RELEASE: 21,
    PENDING_WITHHOLD_RELEASE: 22,
    DECLINED_WITHHOLD_RELEASE: 23,
    PENDING_KNOCK_OFF: 24,
    DECLINED_KNOCK_OFF: 25
});

export const VOUCHER_TYPES = new Map({
    Disbursal: 1,
    Fee: 2,
    Repayment: 3,
    Interest: 4,
    "Knock Off": 5,
    Other: 6,
    Adjustment: 7,
    "Withhold Release": 8
});

export const INTEREST_TYPES = new Map({
    "Interest on Principal": 1,
    "Interest on Adhoc Limit Utilized": 2,
    "Interest on Interest": 3,
    "Interest on Fee": 4,
    "Additional Interest on Principal": 5,
    "Additional Interest on Adhoc Limit Utilized": 6,
    "Additional Interest on Interest": 7,
    "Additional Interest on Fee": 8,
    "Overdue Interest on Principal": 9,
    "Overdue Interest on Interest": 10,
    "Overdue Interest on Fee": 11,
    "Overdue Additional Interest on Principal": 12,
    "Overdue Additional Interest on Interest": 13,
    "Overdue Additional Interest on Fee": 14
});
export const REPAYMENT_TYPES = new Map({
    NACH: 1,
    Cheque: 2,
    NEFT: 3,
    IMPS: 4,
    Pool: 5,
    Others: 6
});

export const FEE_TYPES = new Map({
    "On-boarding Fee": 1,
    "Annual Fee": 2,
    "Overdue Fee": 3,
    "Transaction Processing Fee": 4,
    "Excess Limit Fee": 5,
    "Peak Limit Fee": 6,
    "Adhoc TER Fee": 7,
    "Cheque Bounce Charges": 8,
    "Nach Bounce Charges": 9
});

export const ACCOUNT_TYPES = new Map({
    UNDEFINED: 0,
    SAVING: 1,
    CURRENT: 2,
    OD: 3,
    CC: 4,
    POOL: 5,
    LOAN: 6
});

export const TRANSACTION_TYPES = new Map({
    Debit: 1,
    Credit: 2
});

export const REPAYMENT_DESTINATION_TYPES = new Map({
    UNDEFINED: 0,
    LOAN_ACCOUNT: 1,
    POOL_ACCOUNT: 2,
    OTHERS: 3
});

export const FEE_TYPE_LABELS = new Map({
    "On-boarding Fee": 1,
    "Annual Fee": 2,
    "Overdue Fee": 3,
    "Transaction Processing Fee": 4,
    "Excess Limit Fee": 5,
    "Peak Limit Fee": 6,
    "Adhoc TER Fee": 7,
    "Cheque Bounce Charges": 8,
    "Nach Bounce Charges": 9,
    "Processing Fee": 10,
    "Documentation Charges": 11,
    "Other Charges": 12
});

export const INVOICES_MATURITY_TYPES = new Map({
    last_date_for_cashback: 1,
    soft_due_date: 2,
    due_date: 3
});

export const QUESTIONARE_MASTER = new Map({
    TEXT: 1,
    NUMBER: 2,
    SELECT_SINGLE: 3,
    SELECT_MULTIPLE: 4
});

export const SCORECARD_TYPE = new Map({
    // "Progcap Scorecard": 1,
    "Bank Scorecard": 2,
    "origination Scorecard": 3,
    "Credit Check List Scorecard": 4
});

export const REPORTS_DATA_TYPES = new Map({
    INTEGER: 1,
    FLOAT: 2,
    STRING: 3,
    DATE: 4,
    DATETIME: 5,
    CURRENCY: 6
});

export const REPORTS_FILTER_TYPES = new Map({
    DATE: 1,
    DATETIME: 2,
    INPUT: 3,
    SINGLE_SELECT: 4,
    MULTI_SELECT: 5
});

export const REPORTS_OPTIONS_TYPES = new Map({
    SEARCH: 1,
    SELECT: 2
});

export const PROGRAM_TYPES = new Map({
    "Anchor": 1,
    "Seller": 2
});

export const FACILITY_NAME_TYPES = new Map({
    "Flexiloan": 1
});

export const DUE_DATE_FROM_TYPES = new Map({
    "Disbursal Date": 1,
    "Invoice Date": 2
});

export const PRODUCT_INTEREST_TYPES = new Map({
    "Normal": 1,
    "Overdue": 2
});

export const INTEREST_DEFINITION_TYPES = new Map({
    "Per Day": 1,
    "Per Annum": 2
});

export const PRODUCT_FEE_TYPES = new Map({
    "Annual Fee": 1,
    "Processing Fee": 2
});

export const FEE_CALCULATION_TYPES = new Map({
    "Fixed": 1,
    "Percentage of Limit": 2
});

export const FEE_DEBIT_AT_TYPES = new Map({
    "On Sanction Date": 1,
    "At First Disbursal": 2,
    "On Principal Overdue": 3
});

export const SUPPLY_CHAIN_ROLE_TYPE_CHOICE = new Map({
    "Supplier Program": 5,
    "Master Program": 10,
    "Distributor Program": 15,
    "Retailer Program": 20
});

export const DOCUMENT_TYPE = new Map({
    "Pre Sanction": 1,
    "Post Sanction": 2
});

export const CASE_LEAD_TYPES = new Map({
    "Hot": 1,
    "Warm": 2,
    "Cold": 3
});

export const LOAN_TRACK_OPTIONS = new Map({
    "Either a secured loan OR an unsecured loan track with 12 months of seasoning" : 1,
    "Both Secured Loan and Unsecured Loan Track with 12 months seasoning": 2,
    "Customer has only track of Gold Loan OR Overdraft Or any secured/unsecured loan with delayed repayments": 0
});

export const CURR_INPUT_TYPES = new Map({
    "Rs": 1,
    "%": 2
});
export const RAISE_RFF_TYPES = new Map({
    Buyer: 1,
    Seller: 2
});

export const PROCESS_MASTER_TYPES = new Map({
    "Anchor-On-Boarding": 1,
    "Distributor-On-Boarding": 2,
    "Borrower-On-Boarding": 3
});

export const BOOLEAN_OPTIONS = new Map({
    Yes: true,
    No: false
});

export const TNCCredit = new Map({
    "Takeover case" : 1,
    "Security deposit" : 2,
    "Others": 3,
});

export const NEW_BUSINESS_NATURE_TYPES = new Map({
    "Bonded/Warehouse" : 1,
    "export" : 2,
    "Factory/Manufacturing": 3,
    "Import": 4,
    "Office/Sales Office": 5,
    "Retail Business": 6,
    "Supplier/Services": 7,
    "Warehouse/Depot": 8,
    "Wholesale Business": 9,
    "Works Contract": 10,
    "Others": 11 
});

export const REGION_CATEGORISATION = new Map({
    "Tier 1": 1,
    "Tier 2" :2,
    "Tier 3": 3,
    "Below": 4
});

export const CASE_CATEGORY_TYPES = new Map({
    "New": 1,
    "Enhancement": 2,
    "Re-Open": 3,
    "Amendment": 4,
    "Adhoc": 5,
    "Balance Transfer": 6,
    "Renewal": 7
});
export const PRIMARY_LANGUAGE = new Map({
    "English": 1,
    "Hindi": 2,
});
export const SECONDARY_LANGUAGE = new Map({
    "Tamil": 1,
    "Telugu ": 2,
    "Bengali": 3,
    "Kannada": 4,
    "Gujarati": 5,
    "Marathi": 6,
    "Malayalam": 7,
    "English": 8,
    "Hindi": 9
});
export const KYC_ENUM = new Map({
    "OSV": 1,
    "VKYC": 2
});

export const VALUE_TYPE = new Map({
    "Rupees": 1,
    "Percentage": 2 
});

export const ORDERING_WAYS = new Map({
    "Software": 1,
    "App": 1,
    "On Call": 2,
    "Via SMS": 3,
    "Over Whatsapp": 4,
    "By Your Sales Manager": 5
});

export const CASE_SOURCE = new Map({
    "Sales App": 1,
    "Retail App": 2,
    "Web Portal": 3,
    "Onboarding Portal": 4,
    "Auto": 5
});

export const CASE_ACTIVE_STATUS = new Map({
    Open: 1,
    Rejected: 2,
    Active: 3,
    Closed: 4,
    Hold: 5
});

export const ERP_DATASOURCE = new Map({
    DeW: 1,
    MW: 2,
    OTHERS: 3
});

export const DOCUMENT_CURRENT_STATUS = new Map({
    Requested: 1,
    Verified: 2,
    "Pending Approval": 3,
    Rejected: 4,
    Archived: 5
});

export const DOCUMENT_REJECTION_REASONS = new Map({
    "Document is Inappropriate": 1,
    "Image is Blurred": 2,
    "Document is Unreadable": 3,
    "Document Doesn't match User Data": 4,
    "Document Expired": 5,
    "Document is Incomplete": 6
});

export const LOAN_TYPES = new Map({
    "Salaried Type": 1,
    "Self Employed Type": 2
});

export const LOAN_ACCOUNT_TYPES = new Map({
    "Saving": 1,
    "Saving Self Employed": 2,
    "Current": 3,
    "Cash Credit": 4,
    "Overdraft": 5
});

export const BANK_STATEMENT_ANALYSER_STATUS = new Map({
    Uploaded: 1,
    Submitted: 2,
    Processing: 3,
    Failed: 4,
    Success: 5
});

export const PERFIOS_BANK_STATEMENT_ANALYSER_STATUS = new Map({
    Uploading: 1,
    Uploaded: 2,
    Processing: 3,
    Failed: 4,
    Success: 5
});

export const RCU_VERIFICATION_STATUS_TYPES = new Record({
    VERIFIED: "Verified",
    INITIATED: "Initiated",
    UNINITIATED: "Uninitiated",
    FAILED: "Failed"
})();

export const ACCOUNT_ENTITY_TYPE = new Map({
    Company: 1,
    "Partner Bank": 2
});

export const SCORE_CARD_RANGE = new Map({
    "Undefined": null,
    "A": ">=750",
    "B": ">=700 and <750",
    "C": ">=650 and <700",
    "C1": "-1",
    "D": ">=600 and <650",
    "X": "<600"
});

export const CIBIL_CONDITIONS = new Map({
    "Info Required": 1,
    "Doc Required": 2,
    Both: 3,
    "Any Other": 4
});

export const CIBIL_COMMENTS = new Map({
    Yes: 1,
    No: 2,
    "Conditional Approval": 3
});

export const CASE_ACTIONS_TYPE = new Map({
    PROCEED: 1,
    REFER: 2,
    HOLD: 3,
    REJECT: 4
});

export const SCHEME_TYPE_ENUM = new Map({
    DEFAULT_SCHEME: 1,
    CASH_CARD: 2,
    COMBINATIONAL_SCHEME: 3,
    TERM_LOAN: 4,
    BILL_DISCOUNTING: 5,
    RFF_LEVEL_SCHEME: 6,
    PER_UNIT_SUBVENTION_SCHEME: 7

});

export const HOLDBACK_TYPE = new Map({
    FLDG: 1,
    LMUG: 2,
    "NON-FLDG": 3
});

export const HOLDBACK_SUB_TYPE = new Map({
    "": 0,
    "FLDG Holdback": 1,
    "Cash Margin": 2,
    "FD Lien": 3,
});

export const PROGRAM_TYPE = new Map({
    "Primary": 1,
    "Secondary": 2,
    "PIF": 3,
    "CIF": 4,
    "Vendor Finance": 5,
});

export const PROGRAM_TYPE_NEW = new Map({
    "--":0,
    "Primary" : 1,
    "Secondary" : 2,
});

export const BUSINESS_PRODUCT_TYPE = new Map({
     "Invoice Finance": 1,
     "Vendor Finance" : 2,
     "Working Capital Demand Loan" : 3,
    //  "Renovation Term Loan" : 4,
     "Purchase Invoice Finance" :5,
     "Sales Invoice Finance" : 6,
     "Term Loan" : 7
});


export const BUSINESS_PRODUCT_TYPE_UPDATED = new OrderedMap({
    "INVOICE_FINANCE": 1,
     "VENDOR_FINANCE" : 2,
     "WORKING_CAPITAL_DEMAND_LOAN" : 3,
     "RENOVATION_TERM_LOAN" : 4,
     "PURCHASE_INVOICE_FINANCE" :5,
     "SALES_INVOICE_FINANCE" : 6,
     "TERM_LOAN" : 7,
     "PERSONAL_TERM_LOAN": 8,
     "SHORT_TERM_LOAN": 9,
    "CEP": 10
});

export const SCHEME_TYPE_UPDATED = new Map({
    "DEFAULT_SCHEME": 1,
    "CASH_CARD" : 2,
    "COMBINATIONAL_SCHEME" : 3,
    "TERM_LOAN" : 4,
    "BILL_DISCOUNTING" : 5,
    "RFF_LEVEL_SCHEME" : 6,
    "PER_UNIT_SUBVENTION_SCHEME" : 7,
    "VENDOR_FINANCE" : 8,
    "SUBVENTION_BASIS_INVOICE_DATE" : 9,
    "SUBVENTION_BASIS_CUTOFF_DATE" : 10,
    "CEP": 11
})


export const TL_PRODUCT_TYPE = new Map({
    "Working Capital Demand Loan" : 3,
    "Short Term Loan (STL)" : 9,
    "Personal Term Loan" : 8,
});

export const CPV_STATUS = new Map({
    "Initiated" : 1,
    "Positive" : 2,
    "Negative" : 3,
    "Non serviceable" : 4,
    "Referred" : 5,
    "Completed by sales team" : 6,
    "Deferred" : 7,
    "Not required" : 8,
});

export const FTR_CATEGORY = new Map({
    "FTR" : 1,
    "FTR N" : 2,
});


export const POTENTIAL_RISK_PARAMETERS = new Map({
     "LOR": 1,
     "Billing Issue": 2,
     "Banking: BTO" : 3,
     "Banking: BTO" : 4,
     "Financials: Debt/Equity ratio" : 5,
     "Financials: Leverage" :6,
     "Enhancement: Vintage" : 7,
     "Enhancement Limit: Anchor Reco" : 8,
     "Others" : 9
});

export const BUSINESS_TYPE = new Map({
    "Existing": 1,
    "New": 2,
});

export const RECOURSE_STRUCTURE = new Map({
    "FLDG" : 1,
    "LMUG" : 2,
    "NIL Recourse" : 3,
    "50-50 Risk Sharing" : 4,
    "100-0 Risk Sharing" : 5,
});

export const SECURITY_TYPES = new Map({
    "Holdback" : 1,
     "Upfront Cash" : 2,
     "Bank Guarantee" : 3,
     "FD Lien" : 4,
     "No Holdback" : 5
});

export const CHURN_APPLICABLE = new Map({
    "Yes": true,
    "No": false
});

export const SECURITY_BASIS = new Map({
    "Program Size" : 1,
     "Outstanding" : 2,
     "NPA" : 3,
});

export const FEE_BASIS_TYPE = new Map({
    "Program Size" : 1,
    "AUM Based" : 2,
    "Fixed Upfront" : 3,
    "No Fee" : 4,
});

export const CHARGES_AT_TYPE = new Map({
    "First Disbursal": 1,
    "Account Creation": 2,
    "Manual" : 3,
});

export const PAYMEN_FREQUENCY_TYPE = new Map({
    "One Time" : 1,
    "Quarterly" : 2,
    "Annual" : 3,
});


export const ONBOARDING_STAGES = new Map({
    docs_pending: 48,
    mpa_credit: 49,
    mpa_ccm: 50,
    agreement: 51,
    ops_review: 52,
    r2d_completed: 53
});

export const CORPORATION_TYPE = new Map({
    "Mid Corporate": 1,
    "Large Corporate": 2,
    "New Age Company": 3,
    SME: 4,
});

export const DEFERRAL_CATEGORY = new Map({
    "Security Cheque": 0,
    "PD Pending": 1,
    "Other Doc": 2,
    "No NACH PDC": 3,
    "Physical OSV Pending": 4,
    "BSV": 5,
    "KYC": 6,
    "Partnership Deed": 7,
    "BR/BO" : 8
});

export const REJECT_REASONS = new Map({
    "Wrong Invoice / DRF / PO Number": 12,
    "Non - Supported Format (Word/XL)": 13,
    "Pre & Post Dated Invoice": 14,
    "Incorrect Buyer GSTIN Selection": 15,
    "Amount Mismatch": 16,
    "Miscellaneous": 17,
});

export const DEVIATION_TYPE = [
    {
        label: "Rotation Approval",
        value: 1
    },
    {
        label: "SBD Approval",
        value: 2
    },
    {
        label: "Margin Release",
        value: 3
    },
    {
        label: "Program to retailer level",
        value: 4
    },
    {
        label: "OTP consent not required",
        value: 5
    },
    {
        label: "Margin Adjustment",
        value: 6
    },
    {
        label: "Recredit",
        value: 7
    },
    {
        label: "Cross sell",
        value: 8
    },
    {
        label: "Risk Share",
        value: 9
    }
]

export const SERIES_FUNDED = new Map({
    "Series A" : 1,
     "Series B" : 2,
     "Series C" : 3,
     "Series D" : 4,
     "Series E" : 5,
     "Others" : 6
});

export const AUTHORITY_APPROVAL_STAGE_ID = 54;

export const NACH_MODES_TYPE = new Map({
    API_MANDATE : {
        label: "API Mandate",
        value: 1
    },
    PHYSICAL_MANDATE: {
        label: "Physical Mandate",
        value: 2
    },
    NO_NACH_PDC_ONLY: {
        label: "No Nach-PDC only",
        value: 3
    }
});

export const NACH_STATUS = new Map({
    INITIATED : 1,
    CANCELLED : 2,
    FAILED : 3,
    VERIFIED : 4,
    BANK_CONFIRMED : 5
});

export const DB_TAGGING = new Map({
    "SOS": 1,
    "Samvaad": 2,
    "Growth": 3,
    "Run down": 4,
    "Terminated": 5,
    "Sustain": 6,
});

export const SubventionType = [
    {
        label: "Full Subvention",
        value: "2"
    },
    {
        label: "Partial Subvention",
        value: "1"
    }
];

export const CASE_CATEGORY = new Map({
    "-": 0,
    "ProgShakti": 1,
});

export const SELLER_HOLD_REASONS = new Map({
    "-": 0,
    "Business Closed-Temporarily": 1,
    "Issue with Distributor": 2,
    "Market/Business down": 3,
    "Sufficient stock available": 4,
    "Wants to clear the O/S first": 5,
    "Repayment behaviour is not good": 6,
    "As per the client request": 7,
    "Stock not received": 8,
    "NOC request": 9,
    "Reason not given":10,
    "Initiate closure of account":11,
    "Requested by dealer":12,
    "Limit to be re-sanctioned":13,
    "Security Cheques pending":14,
    "Video KYC pending":15,
    "Repayment Issue":16,
    "Hold By Seller":17,
    "Hold By Lending Partner":18,
    "Overdue":19,
    "Document Pendency":20,
    "Hold by RM":21,
    "Critical":22,
    "Case Summary":23,
    "Hold By Cops":24,
    "No Reply/Response":25,
    "Raised by Sales Team":26,
    "DB not Supportive":27,
    "Re-Credit":28,
    "FI Movement":29,
    "FCU Pending":30,
    "Less stock Received":31,
    "Damaged Stock Received":32,
    "Single Facility closure Request":33,
    "DB tagged misaligned":34,
    "High Risk":35,
    "Welcome call not completed":36,
    "MOU not signed":37,
    "DB Terminated":38,
    "Hold by Collection":39,
    "Hold by CRM":40,
    "Hold by Portfolio":41,
    "Hold by Sales":42,
    "Disputed":43,
    "Terminated":44,
    "Resigned":45,
    "Others": 46,
});
